//= back-end-v2/src/domains/asset_holding/api-schema-dtos/SettlementPayloadDtos.ts

import * as Yup from 'yup'

export interface SelectSettlementOptionPayloadDto {
  assetHolderId: number
  assetHolderSettlementId: number
  acceptedTermsAndIndemnity: boolean
}

export const validateSettlementOptionPayload = (): any => {
  return Yup.object().shape({
    acceptedTermsAndIndemnity: Yup.boolean().isTrue('Please accept the terms and indemnity.').required()
  })
}
